import { styled } from '@mui/material';
import Box from '@mui/material/Box';

export const StyledRuleEditorBox = styled(Box)`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
`;
export const StyledRuleEditorContentBox = styled(Box)`
    display: flex;
    justify-content: space-between;
    height: 100%;
    overflow-x: auto;
`;
export const StyledRulesListBox = styled(Box)`
    padding: 8px;
    display: flex;
    flex-direction: column;
    height: 100%;
`;
export const StyledRuleListTitleBox = styled(Box)`
    display: flex;
    width: 440px;
    height: 48px;
    justify-content: center;
    align-items: center;
    font-family: Roboto;
    font-size: 24px;
    font-weight: 400;
    letter-spacing: 0;
    color: white;
    padding: 10px;
`;
export const StyledRuleListContentBox = styled(Box)`
    margin-top: 2px;
    padding-bottom: 16px;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    color: white;
    background-color: rgba(255, 255, 255, 0.1);
    align-items: center;
    justify-content: center;
    height: fit-content;
`;
